import React, { useState } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Footer from "../Footer";

const allProducts = [
  {
    id: 1,
    brand: "Adidas",
    name: "Casual Shirt",
    price: 899,
    oldPrice: 1299,
    discount: 30,
    category: "Boy",
    color: "blue",
    images: ["img/acc1.webp", "img/acc2.webp", "img/acc3.webp"],
    rating: 4.3,
    viewers:"1.3K",
    stock:"Stock In"
  },
  {
    id: 2,
    brand: "HRX",
    name: "Cotton T-shirt",
    price: 599,
    oldPrice: 899,
    discount: 35,
    category: "Boy",
    color: "red",
    images: ["img/acc2.webp", "img/acc1.webp", "img/acc3.webp"],
     rating: 3.3,
    viewers:"1.1K",
    stock:"Out of Stock"
  },
  {
    id: 3,
    brand: "Levis",
    name: "Printed Shirt",
    price: 1299,
    oldPrice: 1999,
    discount: 40,
    category: "Girl",
    color: "green",
    images: ["img/acc3.webp", "img/acc2.webp", "img/acc4.webp"],
     rating: 5.3,
    viewers:"2K",
    stock:"Out of Stock"
  },
  {
    id: 4,
    brand: "Puma",
    name: "Denim Shirt",
    price: 1499,
    oldPrice: 2499,
    discount: 45,
    category: "Boy",
    color: "yellow",
    images: ["img/acc4.webp", "img/acc1.webp", "img/acc5.webp"],
     rating: 2.3,
    viewers:"1K",
    stock:"Stock In"
  },
  {
    id: 5,
    brand: "Tommy Hilfiger",
    name: "Formal Shirt",
    price: 1999,
    oldPrice: 2999,
    discount: 33,
    category: "Girl",
    color: "pink",
    images: ["img/acc5.webp", "img/acc2.webp", "img/acc4.webp"],
     rating: 2.8,
    viewers:"1.4K",
    stock:"Stock In"
  },
];

const Ethnic = () => {
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedColors, setSelectedColors] = useState([]);
  const [discountFilter, setDiscountFilter] = useState(null);
  const [sortOption, setSortOption] = useState("");
  const [priceRange, setPriceRange] = useState(5000);
  const [hoveredItemId, setHoveredItemId] = useState(null);
  const [selectedRatings, setSelectedRatings] = useState([]);

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const handleCheckboxChange = (value, setter, stateArray) => {
    setter(
      stateArray.includes(value)
        ? stateArray.filter((item) => item !== value)
        : [...stateArray, value]
    );
  };

  const handleDiscountFilter = (value) => {
    setDiscountFilter(discountFilter === value ? null : value);
  };

  const handleSortChange = (e) => {
    setSortOption(e.target.value);
  };

  const filteredProducts = allProducts
    .filter((item) =>
      selectedCategories.length > 0
        ? selectedCategories.includes(item.category)
        : true
    )
    .filter((item) =>
      selectedBrands.length > 0 ? selectedBrands.includes(item.brand) : true
    )
    .filter((item) =>
      selectedColors.length > 0 ? selectedColors.includes(item.color) : true
    )
      .filter((item) =>
    selectedRatings.length > 0
      ? selectedRatings.some((rating) => item.rating >= parseFloat(rating))
      : true
  )

    .filter((item) => item.price <= priceRange)
    .filter((item) => (discountFilter ? item.discount >= discountFilter : true))
    .sort((a, b) => {
      if (sortOption === "1") return b.price - a.price;
      if (sortOption === "2") return a.price - b.price;
      if (sortOption === "3") return b.discount - a.discount;
      return 0;
    });

  return (
    <div>
      <div className="content container-fluid">
        <div className="midsize">
          Home / <span>Casual Shirts For Men</span>
        </div>
        <div className="midsizeplus">
          Casual Shirts For Men <span> - {filteredProducts.length} items</span>
        </div>

        <div className="right sort">
          <select name="type" onChange={handleSortChange}>
            <option value="">Sort By</option>
            <option value="1">Price : High to Low</option>
            <option value="2">Price : Low to High</option>
            <option value="3">Best Discount</option>
          </select>
        </div>

        <div className="row">
          {/* Left Filters */}
          <div className="col-lg-2 col-md-3 col-sm-12 filter-left">
            <div className="filter-heading">FILTERS</div>
            <div className="filters">
              <div className="filter-categories">
                <p>Categories</p>
                {["Boy", "Girl"].map((cat) => (
                  <div key={cat}>
                    <input
                      type="checkbox"
                      onChange={() =>
                        handleCheckboxChange(
                          cat,
                          setSelectedCategories,
                          selectedCategories
                        )
                      }
                    />
                    <label>{cat}</label>
                  </div>
                ))}
              </div>

              <div className="filter-categories">
                <p>Brand</p>
                {["Adidas", "HRX", "Puma", "Levis", "Tommy Hilfiger"].map(
                  (brand) => (
                    <div key={brand}>
                      <input
                        type="checkbox"
                        onChange={() =>
                          handleCheckboxChange(
                            brand,
                            setSelectedBrands,
                            selectedBrands
                          )
                        }
                      />
                      <label>{brand}</label>
                    </div>
                  )
                )}
              </div>

              <div className="filter-categories">
                <p>Price Range</p>
                <input
                  type="range"
                  min={0}
                  max={5000}
                  value={priceRange}
                  onChange={(e) => setPriceRange(e.target.value)}
                />
                <p>Under ₹{priceRange}</p>
              </div>

                         <div className="filter-categories">
                <p>Rating</p>
                {["4", "3", "2"].map(
                  (rating) => (
                    <div key={rating}>
                      <input
                        type="checkbox"
                        onChange={() =>
                          handleCheckboxChange(
                            rating,
                            setSelectedRatings,
                            selectedRatings
                          )
                        }
                      />
                      <label>{rating} ★ & above</label>
                    </div>
                  )
                )}
              </div>

              <div className="filter-categories">
                <p>Color</p>
                {["blue", "red", "green", "yellow", "pink"].map((color) => (
                  <div key={color}>
                    <input
                      type="checkbox"
                      onChange={() =>
                        handleCheckboxChange(
                          color,
                          setSelectedColors,
                          selectedColors
                        )
                      }
                    />
                    <label>
                      <span className={`color-set-${color}`}></span>{" "}
                      {color.charAt(0).toUpperCase() + color.slice(1)}
                    </label>
                  </div>
                ))}
              </div>

              <div className="filter-categories">
                <p>Discount</p>
                {[10, 40, 60, 80].map((val) => (
                  <div key={val}>
                    <input
                      type="checkbox"
                      checked={discountFilter === val}
                      onChange={() => handleDiscountFilter(val)}
                    />
                    <label>{val}% and Above</label>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right Products */}
          <div className="col-lg-10 col-md-9 col-sm-12 products-right">
            <div className="row">
              {filteredProducts.map((item) => (
                <div
                  key={item.id}
                  className="col-lg-3 col-md-4 col-sm-6 product-list"
                  onMouseEnter={() => setHoveredItemId(item.id)}
                  onMouseLeave={() => setHoveredItemId(null)}
                  style={{ position: "relative" }}
                >
                  <Link className="product" to="/model">
                    <div className="image-container">
                      {hoveredItemId === item.id && item.images.length > 1 ? (
                        <Slider {...settings}>
                          {item.images.map((img, idx) => (
                            <img key={idx} src={img} alt={`slide-${idx}`} />
                          ))}
                        </Slider>
                      ) : (
                        <div className="product-img">
                        <img src={item.images[0]} alt={item.name} />
                        <div className="product-rating">
                        <p>{item.rating} <i className="fa-solid fa-star"></i> | {item.viewers}</p>
                        </div>
                        </div>
                      )}
                    </div>

                    {hoveredItemId === item.id && (
                      <div className="wishlist">
                        <button>
                          <i className="fa-regular fa-heart"></i> Wishlist
                        </button>
                      </div>
                    )}

<div className="product-detail">
                    <div className="stock-availability">
                     {item.stock}
                    </div>
                    <div className="brand">{item.brand}</div>
                    <div className="name">{item.name}</div>
                    <div className="price">
                      ₹{item.price}
                      <span className="line-through"> ₹{item.oldPrice}</span>
                      <span className="discount"> ({item.discount}% OFF)</span>
                    </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Ethnic;
